import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Page from './pages/Page';
import SimulatorPage from './pages/SimulatorPage';
function App() {
  return (
    <Router>
   

      <Routes>
        <Route path="/" element={<Page />} />
       <Route path="/sim" element={<SimulatorPage />} />
      </Routes>
    </Router>
  );
}

export default App;
